import { DURING_STAY_SURVEY_SEND_ANSWER_ERROR } from './../const';

function action() {
  return { type: DURING_STAY_SURVEY_SEND_ANSWER_ERROR };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/duringStaySurveySendAnswerError.js